export default __webpack_public_path__ + "static/media/select_down_arrow_disabled.89570885.svg";